import meeting from "@/assets/img/fallbacks/meeting.jpg";
import corenews from "@/assets/img/fallbacks/corenews.png";
import type { IFileState } from "@/interfaces";
import type { FallbackImageType } from "@/types";

const MAP: Record<FallbackImageType, string> = {
  meeting,
  corenews,
};

const loadBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};

const getExtensionFromUrl = (url: string): string => {
  const match = /\.([a-zA-Z0-9]+)(?:[?#]|$)/.exec(url);
  return match && match[1] ? match[1] : "jpg";
};

export default async (type: FallbackImageType): Promise<IFileState> => {
  const imageUrl = MAP[type];
  const base64 = await loadBase64(imageUrl);
  const extension = getExtensionFromUrl(imageUrl);

  return {
    base64,
    name: `${String(type)}.${extension}`,
    type: "image",
    action: "upload",
    isFavorite: true,
    isDefault: true,
  };
};
